import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import { whiteColor } from 'src/constants';

export const useStyles = makeStyles(() => createStyles({
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    alignSelf: 'stretch',
    gap: '8px',
    '& .label': {
      width: '100%',
      padding: '12px',
      borderRadius: '12px',
      border: '1px solid #EFEFEF',
      backgroundColor: whiteColor,
      fontSize: '12px',
      fontWeight: '500',
      lineHeight: '16px',
      color: '#5E5E60',
      '& .boldLabel': {
        fontWeight: '900',
      },
    },
  },
  button: {
    display: 'flex',
    height: '40px',
    backgroundColor: '#EFEFEF!important',
    color: '#5E5E60!important',
    padding: '12px',
    fontSize: '13px',
    fontWeight: '500',
    lineHeight: '16px',
    boxShadow: 'none',
    '&:hover': {
      boxShadow: 'none!important',
    },
  },
}));
